import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
var timer;
export default {
  name: 'springwaterList_s',
  meta: {
    title: '文物综合展示系统'
  },
  data() {
    return {
      singleform: {
        limit: 100,
        page: 1
      },
      firstData: [],
      datas: [],
      showFirst: true,
      datasAll: [],
      showIndex: [1],
      showBgIndex: [1],
      showFirstBg: true,
      config: {},
      stageUrl: '',
      searchKey: '',
      primaryData: [],
      columns: [],
      columnName: '',
      columnIndex: 0,
      types: ['3D', '360', '视频', '图片'],
      a_type: 0,
      showNavs: false,
      autoCloseNav: 0,
      datasLoading: true,
      //数据加载
      totalPage: 1 //总页数
    };
  },
  methods: {
    // 改变栏目
    changeColumn(index, item) {
      this.columnIndex = index;
      this.columnName = item.columnName == '全部' ? '' : item.columnName;
      if (this.columnName == '') return this.datasAll = this.primaryData;
      this.datasAll = this.primaryData.filter(item => {
        return item.columnName == this.columnName;
      });
    },
    // 改变类型
    changeTypes(n) {
      this.a_type = n;
      this.datasAll = this.primaryData.filter(item => {
        return item.type == this.types[n - 1];
      });
    },
    toSearch() {
      if (!this.searchKey) return this.datasAll = JSON.parse(JSON.stringify(this.primaryData));
      this.datasAll = this.primaryData.filter(item => {
        return item.name.indexOf(this.searchKey) > -1;
      });
    },
    toList() {
      this.$router.push({
        name: 'springwaterList',
        query: this.$route.query
      });
    },
    // 获取文物列表
    getsingleformList(type) {
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.formId = 113010;
      this.datasLoading = true;
      this.$api.singleadvanceSearch(this.singleform).then(res => {
        this.datasLoading = false;
        this.totalPage = res.totalPage;
        this.setData(res.dataList);
      });
    },
    //清洗数据
    setData(data) {
      data = data.map(item => {
        let nItem = {
          columnName: this.$route.query.fid == 200375 ? this.getValInFormIdData(item.formIdValueData, 'columns') : this.getValInFormIdData(item.formIdValueData, 'column'),
          name: this.getValInFormIdData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormIdData(item.formIdValueData, 'thumbnail', 'img'),
          code: this.getValInFormIdData(item.formIdValueData, 'autoId'),
          showType: this.getValInFormIdData(item.formIdValueData, 'showType'),
          autoCode: this.getValInFormIdData(item.formIdValueData, 'autoCode'),
          type: this.getValInFormIdData(item.formIdValueData, 'type')
        };
        return nItem;
      });
      data = data.filter(item => {
        return item.showType.indexOf('电脑端与移动端') > -1;
      });
      this.datasAll = this.datasAll.concat(data);
      this.primaryData = this.primaryData.concat(JSON.parse(JSON.stringify(data)));
      if (this.singleform.page < this.totalPage) {
        this.singleform.page++;
        this.getsingleformList('update');
      }
    },
    getValInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }) ? data.find(d => {
        return d.alias == id;
      }).values[0] : '';
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? this.stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    getValInFormIdData(data, id, type, index) {
      index = index ? index : 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        target = process.env.NODE_ENV == 'development' ? data[id].groupValues[index].values[0][0] : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}`;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    getValInFormDataList(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values;
      if (!target) return '';
      target = target.map(item => {
        return item.val;
      });
      return target.join(',');
    },
    toDetail(item) {
      let query = this.$route.query;
      query.code = item.code;
      item.autoCode ? query.autoCode = item.autoCode : item.m_index ? query.index = item.m_index : '';
      this.$router.push({
        name: 'springwaterDetail',
        query: query
      });
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          title: this.getConfigInFormData(data.formData, 'title'),
          logo: this.getConfigInFormData(data.formData, 'logo', 'img')
        };
        document.title = this.config.title || '文物综合展示系统';
      });
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      target.file = process.env.NODE_ENV == 'development' ? this.stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    //获取栏目列表
    getColumn() {
      let query = {
        fid: this.$route.query.fid || '151066',
        formId: 112712,
        page: this.listPage,
        limit: 50
      };
      this.$api.singleformList(query).then(res => {
        this.setColumnData(res.data);
      });
    },
    //栏目信息解析
    setColumnData(data) {
      let list = data.map(item => {
        let nItem = {
          columnName: this.getListData(item.formData, 'name')
          // color: this.getListData(item.formData, 'color')
        };
        return nItem;
      });
      if (list.length > 1) {
        list.unshift({
          columnName: '全部'
        });
      }
      this.columns = list;
      if (this.isMobile) {
        this.$nextTick(() => {
          this.swiperElNav = new Swiper(this.$refs.swiperNav, {
            navigation: {
              nextEl: ".btnRight",
              prevEl: ".btnLeft"
            },
            direction: 'vertical',
            slidesPerView: 'auto',
            centeredSlides: true,
            touchMoveStopPropagation: true,
            runCallbacksOnInit: false,
            observer: true,
            //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            loop: false
          });
        });
      }
    },
    getListData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values[0];
      if (!target) return '';
      return type ? process.env.NODE_ENV == 'development' ? stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '' : target.val;
    },
    toColumn(item, index) {
      this.swiperElNav.slideTo(index);
      this.columnName = item == '全部' ? '' : item;
      if (this.columnName == '') return this.datasAll = this.primaryData;
      this.datasAll = this.primaryData.filter(item => {
        return item.columnName == this.columnName;
      });
    }
  },
  created() {
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    this.getConfig();
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
  },
  mounted() {
    this.singleform.fid = this.$route.query.fid || '151066';
    this.singleform.formId = '112706';
    this.getsingleformList();
    this.getColumn();
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  },
  watch: {
    'autoCloseNav'(val, oldVal) {
      if (val > 3) {
        this.showNavs = false;
        clearInterval(timer);
      }
    }
  }
};